import { render, staticRenderFns } from "./biaya-operasional.vue?vue&type=template&id=23306bee&scoped=true&"
import script from "./biaya-operasional.vue?vue&type=script&lang=js&"
export * from "./biaya-operasional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23306bee",
  null
  
)

export default component.exports